import { render, staticRenderFns } from "./DoorBrokenWindowTiles.vue?vue&type=template&id=2385be29&scoped=true"
import script from "./DoorBrokenWindowTiles.vue?vue&type=script&lang=ts"
export * from "./DoorBrokenWindowTiles.vue?vue&type=script&lang=ts"
import style0 from "./DoorBrokenWindowTiles.vue?vue&type=style&index=0&id=2385be29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2385be29",
  null
  
)

export default component.exports